var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "plus-item" }, [
    _c(
      "button",
      {
        staticClass: "btn plus-button",
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.onAdd.apply(null, arguments)
          },
        },
      },
      [
        _c("span", { staticClass: "button-wrapper" }, [
          _c(
            "svg",
            {
              staticClass: "plus-icon",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M12 3.5V20.5",
                  stroke: "currentColor",
                  "stroke-width": "1.5",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M20.5 12H3.5",
                  stroke: "currentColor",
                  "stroke-width": "1.5",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "plus-text" }, [
            _vm._v(_vm._s(_vm.$t(`${_vm.text}`))),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }